import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TableCell, TableRow, Typography } from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
import { renderRowCreatedAt } from 'utils/renderTableCell';
import { priorityRenderer } from 'helpers/priorityRenderer';

export function TagsRow({ row, index }) {
  const navigate = useNavigate();
  const { createdAt, status, priority, description, firstProductsObj, secondProductsObj } = row;
  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{renderRowCreatedAt('fa-IR', createdAt)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{firstProductsObj?.[0]?.name}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{secondProductsObj?.[0]?.name}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{priorityRenderer(priority)}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{status === 1 ? 'فعال' : 'غیر فعال'}</Typography>
        </TableCell>
        <TableCell align="left">
          <Typography>{description}</Typography>
        </TableCell>
        <TableCell align="left">
          <div onClick={() => navigate('/dashboard/recommendation/conflict/edit', { state: row })} aria-hidden>
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
    </>
  );
}
